export function pushEvent(payload) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch (error) {
    // Analytics must never break the site.
  }
}
